/* global ADV */

import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_EMERGENCY_FUND_GOAL_API } from '../EmergencyFundWorkflowConstants';
import AdvForm from '../../../CommonComponents/AdvForm';
import { inputTextChanged } from '../../../Profile/Accounts_react/AccountsUtils';
import InputDollar from '../../InputDollar/InputDollarView';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import { isVisible } from '../../AdvWorkflow/AdvWorkflowHelpers';

const validator = fundSize => () =>
  isNumeric(fundSize) && +fundSize > 0 ? [] : ['Please enter a valid amount'];

const getRecommendation = (hasPartner, defaultTargetAmount) => {
  const value = `$${ADV.util.number_format(defaultTargetAmount, 0, '.', ',')}`;
  if (hasPartner) {
    return `
      For a married couple, you should have 6 months of your household expenses saved.
      We recommended saving ${value} based on the information you entered
    `;
  }
  return `
    For a single individual, you should have 3 months of your household expenses saved.
    We recommended saving ${value} based on the information you entered.
  `;
};

class TargetAmountView extends React.Component {
  componentDidUpdate(prevProps) {
    const {
      workflowId,
      clientId,
      store,
      targetAmount,
      defaultTargetAmount,
      branch,
      iterator,
      fetchData,
      isPopulated,
    } = this.props;

    if (
      isVisible(branch, iterator) &&
      !prevProps.isPopulated &&
      isPopulated &&
      !targetAmount &&
      defaultTargetAmount
    ) {
      store(workflowId)(
        {
          [BACKEND_EMERGENCY_FUND_GOAL_API]: { FundSize: defaultTargetAmount },
        },
        clientId,
      );
    }

    if (!isVisible(prevProps.branch, prevProps.iterator) && isVisible(branch, iterator)) {
      fetchData(workflowId, clientId);
    }
  }

  render() {
    const {
      workflowId,
      branch,
      clientId,
      store,
      targetAmount,
      defaultTargetAmount,
      isPopulated,
      targetYear,
      hasPartner,
    } = this.props;

    return (
      <AdvWorkflowStep branch={branch} workflowId={workflowId} id="EmergencyFundTargetAmount">
        <Validation
          workflowId={workflowId}
          validationId={`${BACKEND_EMERGENCY_FUND_GOAL_API}.FundSize`}
        />

        <h2>How much would you like to save in case of an emergency?</h2>

        {isPopulated && <h3>{getRecommendation(hasPartner, defaultTargetAmount)}</h3>}

        <AdvForm>
          <ul className="horizontal">
            <li>
              <InputDollar
                placeholder="$ Amount"
                id="adv-amount"
                isUnder
                className="sm text-center"
                value={targetAmount}
                onChange={inputTextChanged(
                  clientId,
                  store(workflowId),
                  `${BACKEND_EMERGENCY_FUND_GOAL_API}.FundSize`,
                )}
              />
            </li>
          </ul>
        </AdvForm>

        <Navigation
          nextIterators={[]}
          dirtyGraphNodes={[]}
          validator={validator(targetAmount)}
          validationId={`${BACKEND_EMERGENCY_FUND_GOAL_API}.FundSize`}
          workflowId={workflowId}
          backendKey={BACKEND_EMERGENCY_FUND_GOAL_API}
          doNotSave={!isNumeric(targetYear)}
        />
      </AdvWorkflowStep>
    );
  }
}

TargetAmountView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store: PropTypes.func.isRequired,
  targetAmount: PropTypes.number.isRequired,
  defaultTargetAmount: PropTypes.number.isRequired,
  iterator: PropTypes.arrayOf(PropTypes.number).isRequired,
  fetchData: PropTypes.func.isRequired,
  isPopulated: PropTypes.bool.isRequired,
  targetYear: PropTypes.number.isRequired,
  hasPartner: PropTypes.bool.isRequired,
};

export default TargetAmountView;
